<div class="container-fluid">
    <div class="row">
        <div class="card-body">
            <div class="row flex-row-reverse">
                <div class="col-12" *ngIf="caseservice.case && caseservice.case.settings.allowEditBasicData">
                    <button class="btn btn-secondary" href="javascript:void(0);" *ngIf="lenAdd == 0"
                        (click)="CreateAddress(AddAddresses);">
                        <i class="fa fa-plus-circle"></i>
                        <span>{{'AddAddress' | translate}}</span>
                    </button>
                </div>
                <div class="card">
                    <table class="table table-striped mt-3">
                        <thead class="bg-primary">
                            <tr>
                                <th scope="col">{{'Region' | translate}} </th>
                                <th scope="col">{{'City' | translate}} </th>
                                <th scope="col">{{'District' | translate}} </th>
                                <th scope="col">{{'Street' | translate}}</th>
                                <th scope="col"> {{'BuildingNumber' | translate}} </th>
                                <th scope="col">{{'longitude' | translate}}</th>
                                <th scope="col"> {{'latitude' | translate}}</th>
                                <th scope="col"> {{"Show" | translate }}</th>
                                <th scope="col"
                                    *ngIf="caseservice.case && caseservice.case.settings.allowEditBasicData">
                                    {{"Edit" | translate }}</th>
                                <!-- <th scope="col" *ngIf="caseservice.case && caseservice.case.settings.allowEditBasicData"> {{"Delete" | translate }}</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let address of addressList">
                                <td>{{address.regionName}}</td>
                                <td>{{address.cityName}}</td>
                                <td>{{address.district}}</td>
                                <td>{{address.street}}</td>
                                <td>{{ address.buildingNumber ? address.buildingNumber : "-" }}</td>
                                <td>{{ address.longitude ? address.longitude : "-" }}</td>
                                <td>{{ address.latitude ? address.latitude : "-" }}</td>

                                <td>
                                    <a (click)="ShowAddress(address,ShowAddresses)" href="javascript:void(0);">
                                        <i class="fa fa-eye"></i>
                                    </a>
                                </td>
                                <td *ngIf="caseservice.case && caseservice.case.settings.allowEditBasicData">
                                    <a (click)="EditAddress(address,editAddresses)" href="javascript:void(0);">
                                        <i class="fa fa-edit"></i>
                                    </a>
                                </td>

                                <!-- <td *ngIf="caseservice.case && caseservice.case.settings.allowEditBasicData">
                                    <a (click)="DeleteAddress(address.caseAdressId, mymodal)" href="javascript:void(0);">
                                        <i class="fa fa-trash"></i>
                                    </a>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>


    </div>
</div>


<ng-template #AddAddresses let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <h4 class="modal-title">
            {{ 'AddAddresses' | translate }}
        </h4>

        <i style="font-size: 20px;" class="fa fa-close" (click)="modal.dismiss('Cross click');"></i>
    </div>
    <form novalidate="">
        <div class="modal-body">
            <div class="form-group  row">
                <google-map #mapp height="200px" width="100%" [center]="center" (centerChanged)="moving(mapp,$event);"> 
                    <map-marker [position]="loc"
                                [options]="markerOptions"></map-marker>


                </google-map>
                <div class="map-center-overlay">
                    <img src="../../../../assets/images/User.jpg" width="30" height="30">
                </div>
                <div class="col-12 offset-1 ">
                    <div class="card rounded-2  flex-md-row row">
                        <div class="form-group m-2 row">
                            <div class="col-lg-4">
                                <label for="Region">{{'Region' | translate}}</label>
                                <span *ngIf="Region.invalid" class="alert" style="color: red;
                                  white-space: nowrap;
                                  line-height: 0;
                                  padding: 0;
                                  margin-top: 8px;">
                                    <span *ngIf="Region.errors?.required">*</span>
                                </span>
                                <ng-select #Region="ngModel" (change)="getRegion($event)" id="Region"
                                           class="form-control-select" [items]="regionsList" bindLabel="text" bindValue="id"
                                           [(ngModel)]="regionId" [ngModelOptions]="{ standalone: true }"
                                           placeholder="{{'Region' | translate}}" required>
                                </ng-select>
                            </div>

                            <div class="col-lg-4">
                                <label for="City"> {{'City' | translate}} </label>
                                <span *ngIf="City.invalid" class="alert" style="color: red;
                                  white-space: nowrap;
                                  line-height: 0;
                                  padding: 0;
                                  margin-top: 8px;">
                                    <span *ngIf="City.errors?.required">*</span>
                                </span>
                                <ng-select [readonly]="!regionId" #City="ngModel" id="City" class="form-control-select"
                                           [items]="citiesList" bindLabel="text" bindValue="id" [(ngModel)]="cityId"
                                           [ngModelOptions]="{ standalone: true }" placeholder="{{'City' | translate}}"
                                           required>
                                </ng-select>

                            </div>
                            <div class="col-lg-4">
                                <label for="weather">{{'weather' | translate}}</label>
                               
                                <ng-select #weather="ngModel" id="weather" class="form-control-select"
                                           [items]="weatherList" bindLabel="text" bindValue="id" [(ngModel)]="weatherTypeId"
                                           [ngModelOptions]="{ standalone: true }"
                                           placeholder="{{'weather' | translate}}">
                                </ng-select>
                            </div>
                        </div>
                        <div class="form-group m-2 row">
                            <div class="col-lg-4">
                                <label for="District"> {{'District' | translate}} </label>
                                <span *ngIf="District.invalid" class="alert" style="
                                  color: red;
                                  white-space: nowrap;
                                  line-height: 0;
                                  padding: 0;
                                  margin-top: 8px;
                                ">
                                    <span *ngIf="District.errors?.required">*</span>
                                </span>
                                <input #District="ngModel" name="District" id="District" [(ngModel)]="district"
                                       type="text" class="form-control" placeholder="{{ 'District' | translate }}"
                                       required />

                            </div>

                            <div class=" col-lg-4">
                                <label for="Street"> {{'Street' | translate}} </label>
                                <span *ngIf="Street.invalid" class="alert" style="
                                color: red;
                                white-space: nowrap;
                                line-height: 0;
                                padding: 0;
                                margin-top: 8px;
                              ">
                                    <span *ngIf="Street.errors?.required">*</span>
                                </span>
                                <input #Street="ngModel" required name="Street" id="Street" [(ngModel)]="street"
                                       type="text" class="form-control" placeholder="{{ 'Street' | translate }}" />
                            </div>

                            <div class="col-lg-4">
                                <label for="BuildingNumber"> {{'BuildingNumber' | translate}} </label>
                                <input #BuildingNumber="ngModel" name="BuildingNumber" id="BuildingNumber"
                                       [(ngModel)]="buildingNumber" type="text" class="form-control"
                                       (keypress)="numberOnly($event)" placeholder="{{ 'BuildingNumber' | translate }}" />
                            </div>
                        </div>

                       
                        <div class="form-group m-2 row">
                            <div class=" col-lg-12">
                                <label for="LocationDescription">{{'locationDescription' | translate}} </label>
                                <span *ngIf="LocationDescription.invalid" class="alert" style="
                                color: red;
                                white-space: nowrap;
                                line-height: 0;
                                padding: 0;
                                margin-top: 8px;
                              ">
                                    <span *ngIf="LocationDescription.errors?.required">*</span>
                                </span>
                                <textarea #LocationDescription="ngModel" name="LocationDescription"
                                          id="LocationDescription" [(ngModel)]="locationDescription" type="text"
                                          class="form-control" required
                                          placeholder="{{ 'locationDescription' | translate }}"></textarea>
                            </div>
                        </div>
                        <div class="form-group m-2 row">
                            <div class="col-lg-4">
                                <label for="Latitude"> {{'latitude' | translate}} </label>
                                <input #Latitude="ngModel" name="Latitude" id="Latitude" [(ngModel)]="latitude"
                                       type="text" (keypress)="allowDecimal($event)" class="form-control"
                                       placeholder="{{ 'latitude' | translate }}" />
                            </div>
                            <div class=" col-lg-4">
                                <label for="Longitude"> {{'longitude' | translate}} </label>
                                <input #Longitude="ngModel" name="Longitude" id="Longitude" [(ngModel)]="longitude"
                                       type="text" class="form-control" (keypress)="allowDecimal($event)"
                                       placeholder="{{ 'longitude' | translate }}" />
                            </div>
                            <div class="col-lg-4">
                                <label for="KLM"> {{'KLM' | translate}} </label>
                                <input #KLM="ngModel" name="KLM" id="KLM" [(ngModel)]="klm" type="text"
                                       class="form-control" placeholder="{{ 'KLM' | translate }}" />
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <div class="modal-footer row" style="justify-content: space-between;padding: 1rem 2rem;">
            <button style="color: black;font-weight: bold;" type="button" class="btn btn-primary col-lg-3"
                data-bs-dismiss="modal"
                [disabled]="Region.invalid || District.invalid || City.invalid || LocationDescription.invalid  || Street.invalid"
                (click)="onCreateAddress();">
                {{"Add" | translate}}
            </button>
            <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click');">
                {{ "Close" | translate }}
            </button>
        </div>
    </form>

</ng-template>



<ng-template #editAddresses let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <div></div>
        <h4 class="modal-title" id="modal-basic-title">
            {{ "EditAddress" | translate }}

        </h4>

        <i style="font-size: 20px;" class="fa fa-close" (click)="modal.dismiss('Cross click');"></i>
    </div>
    <div class="modal-body">
        <div class="form-group  row">
            <google-map #mapp height="200px" width="100%" [center]="center" (centerChanged)="moving(mapp,$event);">
                <map-ground-overlay [url]="imageUrl"
                    [position]="loc"></map-ground-overlay>
                <map-marker [position]="loc"
                            [options]="markerOptions"></map-marker>
            </google-map>
            <div class="map-center-overlay">
                <img src="../../../../assets/images/User.jpg" width="30" height="30">
            </div>
            <div class="col-12 offset-1 ">
                <div class="card rounded-2  flex-md-row row">
                    <div class="form-group col-lg-4">
                        <label for="Region">{{'Region' | translate}}</label>
                        <span *ngIf="Region.invalid" class="alert" style="color: red;
                          white-space: nowrap;
                          line-height: 0;
                          padding: 0;
                          margin-top: 8px;">
                            <span *ngIf="Region.errors?.required">*</span>
                        </span>
                        <ng-select #Region="ngModel" (change)="getRegion($event)" id="Region"
                            class="form-control-select" [items]="regionsList" bindLabel="text" bindValue="id"
                            [(ngModel)]="regionId" [ngModelOptions]="{ standalone: true }"
                            placeholder="{{'Region' | translate}}" required>
                        </ng-select>
                    </div>

                    <div class="form-group col-lg-4">
                        <label for="City"> {{'City' | translate}} </label>
                        <span *ngIf="City.invalid" class="alert" style="color: red;
                          white-space: nowrap;
                          line-height: 0;
                          padding: 0;
                          margin-top: 8px;">
                            <span *ngIf="City.errors?.required">*</span>
                        </span>
                        <ng-select [readonly]="!regionId" #City="ngModel" id="City" class="form-control-select"
                            [items]="citiesList" bindLabel="text" bindValue="id" [(ngModel)]="cityId"
                            [ngModelOptions]="{ standalone: true }" placeholder="{{'City' | translate}}" required>
                        </ng-select>

                    </div>
                    <div class="form-group col-lg-4">
                        <label for="weather">{{'weather' | translate}}</label>
                        
                        <ng-select #weather="ngModel" id="weather" class="form-control-select" [items]="weatherList"
                            bindLabel="text" bindValue="id" [(ngModel)]="weatherTypeId"
                            [ngModelOptions]="{ standalone: true }" required placeholder="{{'weather' | translate}}">
                        </ng-select>
                    </div>
                    <div class="form-group col-lg-4">
                        <label for="District"> {{'District' | translate}} </label>
                        <span *ngIf="District.invalid" class="alert" style="
                          color: red;
                          white-space: nowrap;
                          line-height: 0;
                          padding: 0;
                          margin-top: 8px;
                        ">
                            <span *ngIf="District.errors?.required">*</span>
                        </span>
                        <input #District="ngModel" name="District" id="District" [(ngModel)]="district" type="text"
                            class="form-control" required placeholder="{{ 'District' | translate }}" required />

                    </div>

                    <div class="form-group col-lg-4">
                        <label for="Street"> {{'Street' | translate}} </label>
                        <span *ngIf="Street.invalid" class="alert" style="
                        color: red;
                        white-space: nowrap;
                        line-height: 0;
                        padding: 0;
                        margin-top: 8px;
                      ">
                            <span *ngIf="Street.errors?.required">*</span>
                        </span>
                        <input #Street="ngModel" required name="Street" id="Street" [(ngModel)]="street" required
                            type="text" class="form-control" placeholder="{{ 'Street' | translate }}" />
                    </div>

                    <div class="form-group col-lg-4">
                        <label for="BuildingNumber"> {{'BuildingNumber' | translate}} </label>
                        <input #BuildingNumber="ngModel" name="BuildingNumber" id="BuildingNumber"
                            [(ngModel)]="buildingNumber" type="text" class="form-control"
                            (keypress)="numberOnly($event)" placeholder="{{ 'BuildingNumber' | translate }}" />
                    </div>
                  
                    <div class="form-group col-lg-4">
                        <label for="Longitude"> {{'longitude' | translate}} </label>
                        <input #Longitude="ngModel" name="Longitude" id="Longitude" (keypress)="allowDecimal($event)"
                            [(ngModel)]="longitude" type="text" class="form-control"
                            placeholder="{{ 'longitude' | translate }}" />
                    </div>
                      <div class="form-group col-lg-4">
                        <label for="Latitude"> {{'latitude' | translate}} </label>
                        <input #Latitude="ngModel" name="Latitude" id="Latitude" (keypress)="allowDecimal($event)"
                            [(ngModel)]="latitude" type="text" class="form-control"
                            placeholder="{{ 'latitude' | translate }}" />
                    </div>
                    <div class="form-group col-lg-4">
                        <label for="KLM"> {{'KLM' | translate}} </label>
                        <input #KLM="ngModel" name="KLM" id="KLM" [(ngModel)]="klm" type="text" class="form-control"
                            placeholder="{{ 'KLM' | translate }}" />
                    </div>
                    <div class=" col-lg-12">
                        <label for="LocationDescription">{{'locationDescription' | translate}} </label>
                        <span *ngIf="LocationDescription.invalid" class="alert" style="
                              color: red;
                              white-space: nowrap;
                              line-height: 0;
                              padding: 0;
                              margin-top: 8px;
                            ">
                            <span *ngIf="LocationDescription.errors?.required">*</span>
                        </span>
                        <textarea #LocationDescription="ngModel" name="LocationDescription" id="LocationDescription"
                            [(ngModel)]="locationDescription" type="text" class="form-control" required
                            placeholder="{{ 'locationDescription' | translate }}"></textarea>
                    </div>
                </div>
            </div>

        </div>

    </div>
    <div class="modal-footer row" style="justify-content: space-between;padding: 1rem 2rem;">
        <button style="color: black;font-weight: bold;" type="button" class="btn btn-primary col-lg-3"
            data-bs-dismiss="modal"
            [disabled]="Region.invalid || District.invalid || City.invalid || LocationDescription.invalid  || Street.invalid"
            (click)="onEditAddress();">
            {{"Edit" | translate}}
        </button>
        <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click');">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>
<ng-template #mymodal let-modal>
    <div class="modal-header" style="justify-content: center">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "ConfirmDeleteOperation" | translate }}
        </h4>
    </div>
    <div class="modal-body text-center">
        <p>{{ "SelectedRecordwillbeDeleted" | translate }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDeleteAddress()">
            {{ "YES" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "NO" | translate }}
        </button>
    </div>
</ng-template>



<ng-template #ShowAddresses let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <div></div>
        <h4 class="modal-title" id="modal-basic-title">
            {{ "Show" | translate }}

        </h4>

        <i style="font-size: 20px;" class="fa fa-close" (click)="modal.dismiss('Cross click');"></i>
    </div>
    <div class="modal-body">
        <div class="form-group  row">
            <google-map #mapp height="200px" width="100%" [center]="center2" >
                <map-ground-overlay [url]="imageUrl"
                    [position]="loc"></map-ground-overlay>
                <map-marker [position]="loc"
                            [options]="markerOptions"></map-marker>
            </google-map>
            <div class="map-center-overlay">
                <img src="../../../../assets/images/User.jpg" width="30" height="30">
            </div>
            <div class="col-12 offset-1 ">
                <div class="card rounded-2  flex-md-row row">
                    <div class="form-group col-lg-4">
                        <label for="Region">{{'Region' | translate}}</label>
                        <input readonly #Region="ngModel" name="Region" id="Region" [(ngModel)]="regionName" type="text"
                            class="form-control" />
                    </div>

                    <div class="form-group col-lg-4">
                        <label for="City"> {{'City' | translate}} </label>
                        <input readonly #City="ngModel" name="City" id="City" [(ngModel)]="cityName" type="text"
                            class="form-control" />
                    </div>
                    <div class="form-group col-lg-4">
                        <label for="weather">{{'weather' | translate}}</label>
                        <input readonly #weather="ngModel" name="weather" id="weather" [(ngModel)]="weatherTypeName"
                            type="text" class="form-control" />

                    </div>
                    <div class="form-group col-lg-4">
                        <label for="District"> {{'District' | translate}} </label>

                        <input readonly #District="ngModel" name="District" id="District" [(ngModel)]="district"
                            type="text" class="form-control" placeholder="{{ 'District' | translate }}" required />

                    </div>

                    <div class="form-group col-lg-4">
                        <label for="Street"> {{'Street' | translate}} </label>

                        <input readonly #Street="ngModel" required name="Street" id="Street" [(ngModel)]="street"
                            type="text" class="form-control" placeholder="{{ 'Street' | translate }}" />
                    </div>

                    <div class="form-group col-lg-4">
                        <label for="BuildingNumber"> {{'BuildingNumber' | translate}} </label>
                        <input readonly #BuildingNumber="ngModel" name="BuildingNumber" id="BuildingNumber"
                            [(ngModel)]="buildingNumber" type="text" class="form-control"
                            placeholder="{{ 'BuildingNumber' | translate }}" />
                    </div>
                  
                    <div class="form-group col-lg-4">
                        <label for="Longitude"> {{'longitude' | translate}} </label>
                        <input readonly #Longitude="ngModel" name="Longitude" id="Longitude" [(ngModel)]="longitude"
                            type="text" class="form-control" placeholder="{{ 'longitude' | translate }}" />
                    </div>
                    <div class="form-group col-lg-4">
                        <label for="Latitude"> {{'latitude' | translate}} </label>
                        <input readonly #Latitude="ngModel" name="Latitude" id="Latitude" [(ngModel)]="latitude"
                            type="text" class="form-control" placeholder="{{ 'latitude' | translate }}" />
                    </div>
                    <div class="form-group col-lg-4">
                        <label for="KLM"> {{'KLM' | translate}} </label>
                        <input readonly #KLM="ngModel" name="KLM" id="KLM" [(ngModel)]="klm" type="text"
                            class="form-control" placeholder="{{ 'KLM' | translate }}" />
                    </div>
                    <div class=" col-lg-12">
                        <label for="LocationDescription">{{'locationDescription' | translate}} </label>
                        <textarea readonly #LocationDescription="ngModel" name="LocationDescription"
                            id="LocationDescription" [(ngModel)]="locationDescription" type="text" class="form-control"
                            placeholder="{{ 'locationDescription' | translate }}"></textarea>
                    </div>
                </div>
            </div>

        </div>

    </div>
    <div class="modal-footer row" style="justify-content: space-between;padding: 1rem 2rem;">
        <div class="col-3"></div>
        <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click');">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>